import { h, FunctionComponent } from 'preact'
import styles from './video.module.scss'
import { BoundingBox } from './VideoFeedback'

interface Props {
  centerBounds: BoundingBox
  faceBounds: BoundingBox
  faceYaw: number
  warningMessage: string
  videoWidth: number
  portrait: boolean
}

export const DebugUI: FunctionComponent<Props> = ({
  centerBounds,
  faceBounds,
  faceYaw,
  portrait,
  videoWidth,
  warningMessage,
}: Props) => (
  <div
    className={`${portrait && styles.portraitDebugging}`}
    style={{ width: portrait ? `${videoWidth}px` : '100%' }}
  >
    {centerBounds && (
      <div
        className={styles.videoBounds}
        style={{
          right: `${centerBounds.left}px`,
          top: `${centerBounds.top}px`,
          width: `${centerBounds.width}px`,
          height: `${centerBounds.height}px`,
        }}
      />
    )}
    {faceBounds && (
      <div
        className={styles.faceBounds}
        style={{
          borderColor: `${warningMessage ? 'red' : 'green'}`,
          color: `${warningMessage ? 'red' : 'green'}`,
          right: `${faceBounds?.left}px`,
          top: `${faceBounds?.top}px`,
          width: `${faceBounds?.width}px`,
          height: `${faceBounds?.height}px`,
        }}
      >
        <span className={styles.warningMessage}>Face yaw: {faceYaw}</span>
      </div>
    )}
  </div>
)
